<!--
 * @Author: your name
 * @Date: 2020-11-17 13:28:41
 * @LastEditTime: 2020-11-17 16:58:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \no_reject\src\layout\Mobile\nav.vue
-->
<template>
<div class="container container_01">
      
      <a-row class="we_th" :class="{'isIndex':isPage('apps')}">
      <a-col :span="1" v-if="isPage('apps')">
        &nbsp;
        </a-col>
        <a-col :span="3" v-if="isPage('appall')">
            <router-link :to="'/workflow/index'" class="back">
                <a-icon type="left" :style="{color:'#fff',fontSize:'20px'}"/>
            </router-link>
        </a-col>
        <a-col :span="6" v-if="!isPage('appall') && !isPage('apps')">
            <a-popover v-model="visi_date" trigger="click" placement="bottomLeft">
              <a slot="title">
                <a-tag color="var(--now)" :closable="nowChooseTags?true:false" @close="changeNowTags()">
                  {{ (nowChooseTags || '全部') | noNum}}
                </a-tag>
              </a>
              <div slot="content" style="max-height: 300px;overflow-y: scroll;">
                  <a :key="idx" @click="changeNowTags(ItemTags)" style="display:block;color:#273b6d;text-align:center;font-size:13px;line-height:25px;" v-for="(ItemTags,idx) in chooseTags">{{ItemTags | noNum}}</a>
              </div>
              <a class="nowTag">{{nowChooseTags | noNum}}</a>
            </a-popover>
        </a-col>
        <a-col :span="isPage('appall')?20:16">    
            <a-input-search v-model="SearchAll" placeholder="搜索" style="width:100%;" @search="onSearch" />
        </a-col>
        <a-col :span="6" v-show="isPage('apps')">    
            <span style="font-size:13px;color:var(--now);line-height:30px;text-align:center;">您好,{{$store.getters.getUserInfo.name}}</span>
        </a-col>
        <a-col :span="1" v-show="!isPage('apps')"></a-col>
      </a-row>

      <ul class="common_nav">
			<li>
        <router-link :to="'/workflow/index'">
          <a-icon type="home" class="iconStyle"/>
        办事中心
        </router-link>
      </li>
      <li>
        <router-link :to="'/workflow/todo'">
          <a-icon type="audit" class="iconStyle"/>
          待办
        </router-link>
      </li>
			<li>
				<router-link :to="'/workflow/doing'">
        <a-icon type="clock-circle" class="iconStyle"/>
        进行中</router-link>
			</li>
			<li>
        <router-link :to="'/workflow/done'">
        <a-icon type="file-done" class="iconStyle"/>
          已办结
        </router-link>
      </li>
<!--			<li>-->
<!--				<router-link :to="'/workflow/flow_cc'">-->
<!--        <a-icon type="snippets" class="iconStyle"/>-->
<!--          抄送-->
<!--        </router-link>-->
<!--			</li>-->
		</ul>
</div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      SearchAll:'',
      search_show:false,
      visi_date:false,
      nowChooseTags:'',
      defaultNowTag:'服务类别'
    };
  },
  props: {
    msg: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  mounted(){
    this.nowChooseTags = this.defaultNowTag;
  },
  watch:{
    page_name:{
      handler(val,oldval){
        if(val!=oldval){
          this.SearchAll = null;
          this.nowChooseTags = this.defaultNowTag;
          if(this.isPage('appall')){
              this.SearchAll = this.index_seq;
          }
          if(oldval==='todo' && val!='todo'){
            sessionStorage.removeItem('seq_todo');
          }
        }
        
      },
      deep:true
    },
  },
  inject:['isPage','reload','getSeconds','routeName'],
  methods: {
    signOutOidc(){
      this.$store.dispatch('oidcStore/signOutOidc');
    },
    onSearch(){
      let val = [];
      if(this.SearchAll){
        val.push(this.SearchAll);
      }
      if(this.nowChooseTags && this.nowChooseTags!=this.defaultNowTag){
        val.push(this.nowChooseTags);
      }
      val = val.join(",");
      console.log(val);
      if(!this.isPage('todo') && !this.isPage('apps') && !this.isPage('appall') && !this.isPage('favorite')){
          this.$store.dispatch('SearchQ',{key:this.$route.name,property:'keyword', val});
      }
      if(this.isPage('apps') || this.isPage('appall')){
          val = val?val:'all';
          this.$store.dispatch('updateQuery',{seq:val,tag:'all',dep:'all'});
          this.$router.push({
              path: '/workflow/appall'
          });
      }
      if(this.isPage('todo')){
          sessionStorage.setItem('seq_todo',val);
          this.reload();
      }
      if(this.isPage('favorite')){
          sessionStorage.setItem('seq_fav',val);
          this.reload();
      }

    },
    changeNowTags(Tags){
      this.nowChooseTags = Tags || this.defaultNowTag;
      this.visi_date = false;
      this.onSearch();
    },
    signOutOidc(){
      this.$store.dispatch('oidcStore/signOutOidc');
    },
    showSearch(){
      this.search_show = !this.search_show;
      if(!this.search_now){
        this.$store.dispatch('updateQuery',{seq:'all',tag:'all'});
      }
    },
    
  },
  computed: {
    page_name(){
      return this.$route.name;
    },
    doing_num(){
      let num = this.$store.getters.getState.dataLength.medoing;
      return num;
    },
    ccs_num(){
      let num = this.$store.getters.getState.dataLength.cc;
      return num;
    },
    todo_num(){
      let num = this.$store.getters.getState.dataLength.todo;
      return num;
    },
    index_seq(){
      return this.$store.getters.getState.appQuery.seq;
    },
    chooseTags(){
      return this.$store.getters.getTags;
    }
  },
};
</script>
<style>
.we_th{
  padding:15px 0px;
  text-align:center;
  background:var(--now);
}

.we_th.isIndex{
  background:var(--grey);
}
.we_th.isIndex .ant-input::placeholder{
  color:var(--now);
}
.we_th.ant-row.isIndex .ant-input{
  background:var(--whitegrey);
}
.we_th.ant-row .ant-input{
  background-color: var(--grey);
  border-radius: 20px;
}
.hd_todo{
  background:#282828;
}
.hd_todo .logo1{
  color:#fff;
}
.hd_todo .txt{
  padding-left:40px;
  color:#fff;
  padding-bottom:15px;
}
.hd_todo h1{
  padding-left:40px;
  font-weight:bold;
  color:#fff;
  margin-bottom:10px;
}
.hd_todo p{
  margin-bottom:0px;
}
a.nowTag {
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
  color:#fff;
  line-height:29px;
  border-bottom:2px dotted #fff;
  max-width:90%;
  display: block;
  margin: 0px auto;
}
</style>


// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/nav.vue